{"name": "nextgen-bitbrew-web", "buildversion": "1.0.14_SNAPSHOT_11042026-110108", "buildTime": "04/11/2026 11:01:08"}